"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRole = createRole;
exports.deleteRole = deleteRole;
exports.getRole = getRole;
exports.getRoleAll = getRoleAll;
exports.getRoutes = getRoutes;
exports.updateRole = updateRole;
var _request = _interopRequireDefault(require("@/utils/request"));
function getRoutes() {
  return (0, _request.default)({
    url: '/system/permission/',
    method: 'get'
  });
}
function getRoleAll(query) {
  return (0, _request.default)({
    url: '/system/role/',
    method: 'get',
    params: query
  });
}
function getRole(id) {
  return (0, _request.default)({
    url: "/system/role/".concat(id, "/"),
    method: 'get'
  });
}
function createRole(data) {
  return (0, _request.default)({
    url: '/system/role/',
    method: 'post',
    data: data
  });
}
function updateRole(id, data) {
  return (0, _request.default)({
    url: "/system/role/".concat(id, "/"),
    method: 'put',
    data: data
  });
}
function deleteRole(id) {
  return (0, _request.default)({
    url: "/system/role/".concat(id, "/"),
    method: 'delete'
  });
}